module.exports = __webpack_public_path__ + "img/operating-income.8a463ddf.png";